"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reduxForm = require("redux-form");

var _linkAccountsFormValidation = require("../linkAccountsFormValidation");

var _linkAccountsFormValidation2 = _interopRequireDefault(_linkAccountsFormValidation);

var _reactRouter = require("react-router");

var _Header = require("./Header");

var _Header2 = _interopRequireDefault(_Header);

var _ButtonsGroup = require("./ButtonsGroup");

var _ButtonsGroup2 = _interopRequireDefault(_ButtonsGroup);

var _Button = require("../../EpicEula/components/Button");

var _Button2 = _interopRequireDefault(_Button);

var _TextInput = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/TextInput");

var _TextInput2 = _interopRequireDefault(_TextInput);

var _components = require("components");

var _LinkEpicAccountBox = require("./LinkEpicAccountBox.scss");

var _LinkEpicAccountBox2 = _interopRequireDefault(_LinkEpicAccountBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LinkEpicAccountBox = function (_React$Component) {
  (0, _inherits3.default)(LinkEpicAccountBox, _React$Component);

  function LinkEpicAccountBox() {
    (0, _classCallCheck3.default)(this, LinkEpicAccountBox);
    return (0, _possibleConstructorReturn3.default)(this, (LinkEpicAccountBox.__proto__ || (0, _getPrototypeOf2.default)(LinkEpicAccountBox)).apply(this, arguments));
  }

  (0, _createClass3.default)(LinkEpicAccountBox, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          email = _props.email,
          submitting = _props.submitting,
          fields = _props.fields,
          error = _props.error,
          handleSubmit = _props.handleSubmit;


      var linkingAccountsWithMismatchingEmails = fields.epicLinkEmail && fields.quixelEmail;
      var emailLabel = linkingAccountsWithMismatchingEmails ? "Quixel Email" : "Email";
      var passwordLabel = linkingAccountsWithMismatchingEmails ? "Password" : "Password";

      return _react2.default.createElement(
        _components.Popup,
        null,
        _react2.default.createElement(
          "form",
          { className: _LinkEpicAccountBox2.default.linkEpicAccountBox, onSubmit: handleSubmit },
          _react2.default.createElement(
            _components.Popup.Header,
            null,
            "Link Accounts"
          ),
          _react2.default.createElement(
            "div",
            { className: _LinkEpicAccountBox2.default.linkEpicAccountBoxInner },
            linkingAccountsWithMismatchingEmails ? _react2.default.createElement(
              "p",
              null,
              "Link your Epic Games account to your Quixel account. Enter your Quixel password to continue."
            ) : _react2.default.createElement(
              "p",
              null,
              "Your Epic Games email is also connected to a Quixel account. Enter your Quixel password for continued access to your downloaded assets and Megascans points record."
            ),
            _react2.default.createElement(
              "div",
              { className: _LinkEpicAccountBox2.default.formFields },
              fields.epicLinkEmail && fields.epicLinkEmail.value ? _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({
                label: "Epic Account Email",
                type: "email",
                className: _LinkEpicAccountBox2.default.emailField
              }, fields.epicLinkEmail, {
                disabled: false
              })) : null,
              _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({
                label: emailLabel,
                type: "email",
                className: _LinkEpicAccountBox2.default.emailField
              }, fields.quixelEmail, {
                disabled: false
              })),
              _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({
                label: passwordLabel,
                type: "password",
                placeholder: "Please enter your Quixel account password",
                autoFocus: true
              }, fields.password)),
              !submitting && error ? _react2.default.createElement(
                "span",
                { className: _LinkEpicAccountBox2.default.error },
                error
              ) : null
            )
          ),
          _react2.default.createElement(
            _components.Popup.Footer,
            null,
            _react2.default.createElement(
              "div",
              { className: _LinkEpicAccountBox2.default.footerContainer },
              _react2.default.createElement(
                _ButtonsGroup2.default,
                null,
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: { pathname: "/forgot", state: { modal: true } } },
                  "Reset Password"
                ),
                _react2.default.createElement(
                  _reactRouter.Link,
                  {
                    to: "mailto:support@quixel.se",
                    target: "_blank",
                    rel: "noopener noreferrer"
                  },
                  "Contact Support"
                )
              ),
              _react2.default.createElement(
                "div",
                { className: _LinkEpicAccountBox2.default.button },
                _react2.default.createElement(_Button2.default, {
                  loading: submitting,
                  small: true,
                  smallSize: true,
                  fullWidth: true,
                  type: "submit",
                  primary: true,
                  label: "Link Now"
                })
              )
            )
          )
        )
      );
    }
  }]);
  return LinkEpicAccountBox;
}(_react2.default.Component);

exports.default = (0, _reduxForm.reduxForm)({
  fields: ["epicLinkEmail", "quixelEmail", "password"],
  form: "link-epic-account",
  validate: _linkAccountsFormValidation2.default
})(LinkEpicAccountBox);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/EpicMigration/components/LinkEpicAccountBox.jsx
// module id = 2944
// module chunks = 0